<template>
  <div class="contractselection">
    <!--<h1 class="contractselection__title">Välj avtal</h1>-->

    <div v-if="$root.tagInEditMode('searchcontracts', false)">
      <SearchContracts />
    </div>
    <div v-if="$root.tagInViewMode('searchcontracts', false)" v-on:click="$root.tagSetEditMode('searchcontracts')">
      <SearchContractsViewer />
    </div>
    
    <div v-if="$root.tagHasBeenVisited('searchcontracts')">

      <div v-if="$root.tagInEditMode('energysource', false)">
        <EnergySourceSelection />
      </div>
      <div v-if="$root.tagInViewMode('energysource', false)" v-on:click="$root.tagSetEditMode('energysource')">
        <EnergySourceSelectionViewer />
      </div>
      
      <div v-if="$root.tagInEditMode('bonuscode', false)">
        <BonusCodeSelection />
      </div>
      <div v-if="$root.tagInViewMode('bonuscode', false)" v-on:click="$root.tagSetEditMode('bonuscode')">
        <BonusCodeSelectionViewer />
      </div>

      <!-- Om detailShow == 'contractselection', visa denna -->

      <div v-if="$root.tagInEditMode('contractselection')">
        <ContractSelection />
      </div>
      <div v-if="$root.tagInViewMode('contractselection')" v-on:click="$root.tagSetEditMode('contractselection')">
        <ContractSelectionViewer />
      </div>

      <div v-if="$root.tagInEditMode('customeridentity', false)">
          <CustomerIdentity />
      </div>
      <div v-if="$root.tagInViewMode('customeridentity')" v-on:click="$root.tagSetEditMode('customeridentity')">
          <CustomerIdentityViewer />
      </div>
      <div v-if="$root.tagInDisabledMode('customeridentity')">
          <CustomerIdentityDisabled />
      </div>

      <div v-if="$root.tagInEditMode('customerold', false)">
          <CustomerOld />
      </div>
      <div v-if="$root.tagInViewMode('customerold')" v-on:click="$root.tagSetEditMode('customerold')">
          <CustomerOldViewer />
      </div>
      <div v-if="$root.tagInEditMode('customernew', false)">
          <CustomerNew />
      </div>
      <div v-if="$root.tagInViewMode('customernew')" v-on:click="$root.tagSetEditMode('customernew')">
          <CustomerNewViewer />
      </div>

      <div v-if="$root.tagInDisabledMode('customernew') && $root.tagInDisabledMode('customerold')">
          <CustomerNewDisabled />
      </div>

      <div v-if="$root.tagInEditMode('movingin', false)">
          <MovingIn />
      </div>
      <div v-if="$root.tagInViewMode('movingin')" v-on:click="$root.tagSetEditMode('movingin')">
          <MovingInViewer />
      </div>

      <div v-if="$root.tagInDisabledMode('movingin') && !$root.tagInViewMode('customerold') && !$root.tagInViewMode('customernew')">
          <MovingInDisabled />
      </div>

      <div v-if="$root.tagInEditMode('newstartdate', false)">
          <NewStartDate />
      </div>

      <div v-if="$root.tagInEditMode('ordersummary', false)">
        <OrderSummary />
      </div>
      <div v-if="$root.tagInDisabledMode('ordersummary')">
        <OrderSummaryDisabled />
      </div>

      <div v-if="$root.tagInEditMode('bankidsign', false)">
        <BankIdSign />
      </div>
      <div v-if="$root.tagInDisabledMode('bankidsign')">
        <BankIdSignDisabled />
      </div>

      <!-- ViewMode - SearchContracts -->
    </div>
  </div>
</template>

<script>
import CustomerNew from "@/components/customernew/CustomerNew.vue";
import CustomerNewViewer from "@/components/customernew/CustomerNewViewer.vue";
import CustomerNewDisabled from "@/components/customernew/CustomerNewDisabled.vue";

import MovingIn from "@/components/movingin/MovingIn.vue";
import MovingInViewer from "@/components/movingin/MovingInViewer.vue";
import MovingInDisabled from "@/components/movingin/MovingInDisabled.vue";

import NewStartDate from "@/components/newstartdate/NewStartDate.vue";

import CustomerOld from "@/components/customerold/CustomerOld.vue";
import CustomerOldViewer from "@/components/customerold/CustomerOldViewer.vue";

import CustomerIdentity from "@/components/customeridentity/CustomerIdentity.vue";
import CustomerIdentityViewer from "@/components/customeridentity/CustomerIdentityViewer.vue";
import CustomerIdentityDisabled from "@/components/customeridentity/CustomerIdentityDisabled.vue";

import SearchContracts from "@/components/searchcontracts/SearchContracts.vue";
import SearchContractsViewer from "@/components/searchcontracts/SearchContractsViewer.vue";

import EnergySourceSelection from "@/components/energysourceselection/EnergySourceSelection.vue";
import EnergySourceSelectionViewer from "@/components/energysourceselection/EnergySourceSelectionViewer.vue";

import BonusCodeSelection from "@/components/bonuscodeselection/BonusCodeSelection.vue";
import BonusCodeSelectionViewer from "@/components/bonuscodeselection/BonusCodeSelectionViewer.vue";

import ContractSelection from "@/components/contractselection/ContractSelection.vue";
import ContractSelectionViewer from "@/components/contractselection/ContractSelectionViewer.vue";
import OrderSummary from "@/components/ordersummary/OrderSummary.vue";
import OrderSummaryDisabled from "@/components/ordersummary/OrderSummaryDisabled.vue";
import BankIdSign from "@/components/bankid/BankIdSign.vue";
import BankIdSignDisabled from "@/components/bankid/BankIdSignDisabled.vue";

export default {
  components: { CustomerNew, CustomerNewViewer, CustomerNewDisabled, CustomerIdentity, CustomerIdentityViewer, CustomerIdentityDisabled,
    CustomerOld, CustomerOldViewer,
    MovingIn, MovingInDisabled, MovingInViewer, 
    NewStartDate,
    SearchContracts, SearchContractsViewer, 
    EnergySourceSelection, EnergySourceSelectionViewer, 
    BonusCodeSelection, BonusCodeSelectionViewer, 
    ContractSelection, ContractSelectionViewer, OrderSummary, OrderSummaryDisabled,
    BankIdSign, BankIdSignDisabled },
  methods: {
    submit() {
      if ((this.$root.price_type == 'fixed' || this.$root.price_type == 'mix5050') && !this.$root.is_fixed_contract_available()) {
            return false;
      }
      
      //this.$router.push({ name: 'customernew' })
    }/*,
    showDetails(tag) {
        if(this.$root.detailsShow == tag) {
            this.$root.detailsShow = '';
        }else{
            this.$root.detailsShow = tag;
        }
    }*/
  },
  created() {
      this.$root.tagSetEditMode('searchcontracts');
      /*
      var moment = require('moment');
      if(this.$root.asap){
          var now = new Date();

          var date = new Date(now.getFullYear(), now.getMonth(), now.getDate()+21); // Today + 21 days;

          if (date.getDate() > 1) {
              date = new Date(date.getFullYear(), date.getMonth() + 1, 1); // go to next month directly!
          }

          if(this.$root.customer === 'new' && this.$root.old_customer_type === 'moving')
              date = new Date(now.getFullYear(), now.getMonth(), now.getDate()+5); // Today + 5 days

          if(this.$root.customer === 'old')
              date = new Date(now.getFullYear(), now.getMonth()+1, 1); // First day in next month

          this.$root.contract.date = moment(date).format("YYYY-MM-DD");
      }else{
          this.$root.contract.date = moment(this.$root.start).format("YYYY-MM-DD");
      }
      */

  },
  mounted() {
	console.log('mounted');
  }
}
</script>
<style lang="scss">
  @import '~@/components/range/range';
  .price__type__hidden {
      display: none !important;
  }
  .price__type__selected {
      border: 1px solid  #57a3af;
  }
  .bonuscode__selection {
      background-color:#f8f8f8;
      padding:1.33333rem;
      margin: 0.72222rem 0 1.33333rem;
      border: 1px solid #d6d6d6;
  }
  .energysource__selection {
      background-color:#f8f8f8;
      padding:1.33333rem;
      margin: 0.72222rem 0 1.33333rem;
      border: 1px solid #d6d6d6;
  }
  .bonuscode__textlink {
      @include media('>lg') {
      }
      @include media('<=lg') {
        display: none;
      }
  }
  .energysource__textlink {
      @include media('>lg') {
      }
      @include media('<=lg') {
        display: none;
      }
  }  
  .addonselections {
      /*padding: 1.33333rem;*/
  }
  .contractselection {
    &__title {
      /*text-align: center;*/
      margin: 0;
      @include font-primary(bold);
      @include media('>lg') {
        font-size: rem(26);
      }
      @include media('<=lg') {
        font-size: rem(22);
        line-height: (36/22);
      }
    }
    &__subtitle {
      text-align: center;
      @include media('>lg') {
        margin: rem(14) 0 rem(40);
        font-size: rem(18);
        line-height: (28/18);
      }
      @include media('<=lg') {
        margin: rem(13) 0 rem(28);
        font-size: rem(15);
        line-height: (23/15);
      }
    }
    &__types {
      display: flex;
    }
    &__type {
      flex: 1 1;
      text-align: center;
    }
    &__type-field {
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
    }
    &__type-label {
      @include font-primary(bold);
      height: 100%;
      @include media('>lg') {
        font-size: 18px;
        line-height: (23/18);
      }
      @include media('<=lg') {
      }
      display: block;
      position: relative;
      border: 1px solid $light-border-color;
      padding: rem(34 + 16 + 26) rem(16) rem(16);
      svg {
        position: absolute;
        width: auto;
        height: rem(34);
        left: 50%;
        transform: translate(-50%, 0);
        top: rem(26);
      }
    }
    &__type:not(:first-child) &__type-label {
      margin-left: -1px;
    }
    &__type:first-child &__type-label {
      border-top-left-radius: rem(3);
      border-bottom-left-radius: rem(3);
    }
    &__type:last-child &__type-label {
      border-top-right-radius: rem(3);
      border-bottom-right-radius: rem(3);
    }
    &__type:hover &__type-label {
      border-color: $dark-border-color;
      z-index: 1;
    }
    &__type-field:checked + &__type-label {
      border-color: $primary-color;
      border-width: 2px;
      margin-left: -2px;
      z-index: 2;
    }
    &__type-field:focus + &__type-label {
      border-color: $dark-border-color;
      z-index: 1;
    }
    &__estimated {
      text-align: center;
      margin: rem(32) 0;
    }
    &__direct-watts {
      text-align: center;
      margin: rem(29) 0 rem(50);
    }
    &__direct-watts-label {
      display: block;
      color: $secondary-text-color;
      @include media('>lg') {
        font-size: rem(22);
      }
      @include media('<=lg') {
        font-size: rem(15);
      }
      margin-bottom: rem(26);
      margin-top: rem(14);
    }
    &__direct-watts-field {
      @include unstyled-text-field;
      @include font-primary(bold);
      width: 4em;
      @include media('>lg') {
        font-size: rem(46);
        margin-right: rem(19);
      }
      @include media('<=lg') {
        font-size: rem(26);
        margin-right: rem(12);
      }
      border-bottom: 2px solid $primary-color;
      text-align: center;
      color: $primary-color;
    }
    &__direct-watts-range {
      @include range;
    }
    &__price-types {
      @include media('>lg') {
        margin: rem(29) 0;
      }
      @include media('<=lg') {
        margin: rem(30) 0 rem(15);
      }
    }
    &__price-types-title {
      @include font-primary(bold);
      float: left;
      color: $secondary-text-color;
      margin: 0;
      line-height: 1.4rem;
      @include media('>lg') {
        font-size: rem(22);
      }
      @include media('<=lg') {
        font-size: rem(18);
      }
    }
    &__price-types-subtitle {
      margin: 0;
      float: right;
      line-height: 1.4rem;
      @include media('>lg') {
        font-size: rem(16);
      }
      @include media('<=lg') {
        font-size: rem(13);
      }
      a {
        color: $primary-color;
      }
    }
    &__price-types-list {
      clear: both;
      display: flex;
      margin: 0;
      padding: 0;
      list-style-type: none;
      @include media('>lg') {
        padding-top: rem(15);
      }
      @include media('<=lg') {
        padding-top: rem(11);
      }
    }
    &__price-types-list-item {
      margin: 0;
      padding: 0;
      flex: 1 1;
    }
    &__price-type {
      position: relative;
    }
    &__price-type-field {
      position: absolute;
      opacity: 0;
    }
    &__price-type-label {
      display: block;
      height: 100%;
      cursor: pointer;
      border: 1px solid $light-border-color;
      text-align: center;
      padding: rem(17) 0;
      small {
        display: block;
      }
      @include media('>lg') {
        @include font-primary(bold);
        font-size: rem(36);
        small {
          @include font-primary;
          font-size: rem(22);
        }
      }
      @include media('<=lg') {
        @include font-primary(bold);
        font-size: rem(22);
        small {
          @include font-primary;
          font-size: rem(15);
        }
      }
      &:hover {
        border-color: $dark-border-color;
        z-index: 1;
      }
    }
    &__price-types-list-item:not(:first-child) &__price-type-label {
      margin-left: -1px;
    }
    &__price-types-list-item:first-child &__price-type-label {
      border-top-left-radius: rem(3);
      border-bottom-left-radius: rem(3);
    }
    &__price-types-list-item:last-child &__price-type-label {
      border-top-right-radius: rem(3);
      border-bottom-right-radius: rem(3);
    }
    
    &__price-type-field:checked + &__price-type-label {
      border-color: $primary-color;
      background: $primary-color;
      color: #fff;
      z-index: 2;
    }
    &__price-type-field:focus + &__price-type-label {
      background-color: $light-bg-color;
    }
    &__price-type-field:checked:focus + &__price-type-label,
    &__price-type-field:checked + &__price-type-label:hover {
      background-color: darken($primary-color, 10%);
    }
    &__commitment {
      display: flex;
      align-items: center;
      @include media('>lg') {
      }
      @include media('<=lg') {
        flex-wrap: wrap;
      }
    }
    &__commitment-title {
      font-size: inherit;
      margin: 0;
      color: $secondary-text-color;
      @include media('<=lg') {
        margin-bottom: rem(14);
        flex-basis: 100%;
      }
    }
    &__commitment-wrapper {
      position: relative;
      @include media('>lg') {
        padding-left: rem(16);
      }
      @include media('<=lg') {
        padding-left: rem(13);
      }
    }
    &__commitment-title + &__commitment-wrapper {
      @include media('>lg') {
        padding-left: rem(25);
      }
      @include media('<=lg') {
        padding-left: 0;
      }
    }
    &__commitment-field {
      position: absolute;
      opacity: 0;
    }
    &__commitment-label {
      display: block;
      color: $primary-color;
      border: 1px solid $light-border-color;
      border-radius: 3px;
      line-height: 1;
      /*padding: rem(8) rem(15);*/
      
      white-space: nowrap;
      cursor: pointer;
      @include media('>lg') {
        font-size: rem(16);
		padding: rem(16) rem(30);
      }
      @include media('<=lg') {
        font-size: rem(15);
		padding: rem(8) rem(15);
      }
      &:hover {
        border-color: $dark-border-color;
      }
    }
    &__commitment-field:checked + &__commitment-label {
      background-color: $primary-color;
      border-color: $primary-color;
      color: #fff;
    }
    &__commitment-field:checked + &__commitment-label:hover,
    &__commitment-field:checked:focus + &__commitment-label {
        background-color: darken($primary-color, 10%);
    }
    &__summary {
      display: block;
      background-color: $light-bg-color;
      @include media('>lg') {
        padding: rem(24);
        margin: rem(31) 0 rem(24);
      }
      @include media('<=lg') {
        padding: rem(16);
        margin: rem(24) rem(-16) rem(16);
      }

    }
    &__summary-content {
      @include media('>lg') {
        font-size: rem(16);
        line-height: rem(24);
      }
      @include media('<=lg') {
        font-size: rem(13);
        line-height: rem(21);
      }
      color: $secondary-text-color;
    }
    &__summary-content-title {
      @include font-primary;
      @include media('>lg') {
        font-size: rem(26);
        margin: rem(35) 0 rem(16);
      }
      @include media('<=lg') {
        font-size: rem(22);
        margin: rem(26) 0 rem(10);
      }
      line-height: rem(24);
    }
    &__summary-details {
      position: relative;
         }
    &__summary-details-title {
      float:right;
      display: inline-block;
      text-align: center;
      padding-top: 16px;
      cursor: pointer;
      color: $primary-color;
      @include media('>lg') {
        font-size: rem(20);
      }
      @include media('<=lg') {
        font-size: rem(18);
      }

      line-height: rem(24);
      svg {
        width: rem(10);
        height: rem(10);
      }
      path {
        fill: $primary-color;
      }
      
      list-style-type: none;
      &::marker {
        display: none;
      }
      &::-webkit-details-marker {
        display: none;
      }
    }
    &__summary-details-title.open svg {
      transform: rotate(180deg);
    }
    &__summary-title {
      @include font-primary(bold);
      @include media('>lg') {
        font-size: rem(22);
      }
      @include media('<=lg') {
        font-size: rem(18);
      }
      margin: 0;
    }
    &__summary-subtitle {
      margin: 0;
      @include media('>lg') {
        font-size: rem(36);
      }
      @include media('<=lg') {
        margin: rem(8) 0;
        font-size: rem(26);
      }

      line-height: 49/36;
      b {
        @include font-primary(bold);
        color: $primary-color;
      }
      i {
        color: #c00;
        font-style: normal;
      }
      &-small {
          font-size: 18px;
          margin-top: 0;
          font-weight: bold;
      }
    }
    &__summary-disclaimer {
      color: $secondary-text-color;
      @include font-primary(roman);
      font-size: rem(13);
      b {
        color: #c00;
      }
    }
    &__summary-features {
      @include media('>lg') {
        display: flex;
        flex-wrap: wrap;
        margin: 0 rem(-16) 0 0;
      }
    }
    &__summary-feature {
      @include font-primary(bold);
      flex-basis: 50%;
      position: relative;
      margin: 0;
      @include media('>lg') {
        padding: rem(8) rem(16) rem(8) rem(32);
        font-size: rem(16);
      }
      @include media('<=lg') {
        padding: rem(8) 0 rem(8) rem(32);
        font-size: rem(15);
      }
      svg {
        position: absolute;
        left: 0;
        top: rem(16/2);
        width: rem(16);
        height: rem(16);
      }
      polygon {
        fill: $primary-color;
      }
    }
    &__estimated-fields {
      @include media('>lg') {
        display: flex;
        margin: 0 rem(-12);
      }
      @include media('<=lg') {
      }
    }
    &__estimated-field-wrapper {
      @include font-primary(bold);
      color: $secondary-text-color;
      @include media('>lg') {
        font-size: rem(18);
        flex: 1 1;
        margin: 0 rem(12);
      }
      @include media('<=lg') {
        font-size: rem(16);
        display: block;
        margin: 1rem 0 0;
      }
      &--dropdown {
        position: relative;
        &:before {
          content: '';
          position: absolute;
          right: rem(16+(14*2));
          bottom: 0;
          height: rem(16+(14*2));
          border-left: 1px solid $light-border-color;
        }
        select {
          background-image: url('~@/assets/images/icons/chevron-down-regular.svg');
          background-repeat: no-repeat;
          background-position: calc(100% - 1em) 50%;
          cursor: pointer;
        }
      }
    }
    &__estimated-field {
      @include unstyled-text-field;
      @include font-primary;
      border: 1px solid $light-border-color;
      &:hover,
      &:focus {
        border-color: $primary-color;
      }
      padding: rem(14);
      height: rem(16+(14*2));
      line-height: 1;
      display: block;
      width: 100%;
      margin: rem(12) 0 0;
      @include media('>lg') {
        font-size: rem(16);
      }
      @include media('<=lg') {
        font-size: rem(15);
      }
    }
    &__estimated-calculation {
      text-align: center;
    }
    &__estimated-calculation-title {
      @include font-primary;
      margin: 0;
      padding: 0;
      @include media('>lg') {
        font-size: rem(16);
      }
      @include media('<=lg') {
        font-size: rem(15);
      }
    }
    &__estimated-calculation-text {
      @include font-primary;
      margin: 0;
      padding: 0;
      b {
        vertical-align: middle;
      }
      @include media('>lg') {
        font-size: rem(22);
        b {
          font-size: rem(46);
        }
      }
      @include media('<=lg') {
        font-size: rem(15);
        b {
          font-size: rem(26);
        }
      }
    }
  }  


  .uppgifter {
    &__title {
      text-align: center;
      margin: 0 0 rem(30);
      @include font-primary;
      @include media('>lg') {
        font-size: rem(26);
      }
      @include media('<=lg') {
        font-size: rem(22);
        line-height: (36/22);
      }
    }
    &__block {
      margin-bottom: rem(40);
    }
    &__block-title {
      @include font-primary(bold);
      color: $secondary-text-color;
      margin: 0 0 rem(6);
      font-size: rem(18);
    }
    &__block-subtitle {
      @include font-primary(roman);
      margin: 0;
      margin: 0 0 rem(16);
      font-size: rem(16);
    }
    &__field-wrapper {
      position: relative;
      display: block;
      margin-bottom: rem(16);
    }
    &__field {
      position: absolute;
      opacity: 0;
    }
    &__field-content {
      border: 1px solid $light-border-color;
      border-radius: 3px;
      display: block;
    }
    &__field:focus + &__field-content,
    &__field-content:hover {
      border-color: $dark-border-color;
    }
    &__field:checked + &__field-content {
      border-color: $primary-color;
      border-width: 2px;
    }
    &__field-label {
      display: block;
      @include font-primary;
      font-size: rem(18);
      padding: rem(19);
    }
    .info-circle {
      font-size: rem(16);
      padding-top: 2px;
      margin-bottom: -2px;
      position: absolute;
      margin-left: 8px;
    }
    &__field-label-info {
      font-size: rem(16);
      float: right;
    }
    &__field:checked + &__field-content &__field-label {
      @include font-primary(bold);
    }
    &__field-wrapper--asap-false &__field-content {
      display: flex;
      align-items: center;
    }
    &__field-wrapper--asap-false &__field-label {
      flex: 1 1;
    }
    &__field-wrapper--asap-false &__field-extra {
      position: relative;
      z-index: 1;
      right: rem(16);
    }
    &__calendar-wrapper {
      display: inline-block;
    }
    &__calendar#{&}__calendar { // double class to have more specificity than default styles
      right: 0;
      top: 0;
      padding: 1em;
      border: 0;
      box-shadow: 0 0 8px 3px rgba(0, 0, 0, 0.06);
      color: $secondary-text-color;
      header {
        @include font-primary(bold);
        font-size: 1em;
      }
      .cell {
        &.day {
          @include font-primary(roman);
          position: relative;
          z-index: 1;
          font-size: ((13/18) * 1em);
          border: 1px solid;
          margin: -1px 0 0 -1px;
          width: calc((100% / 7) + 1px);
          &.blank {
            border-color: transparent;
          }
          &:not(.disabled):not(.blank):hover {
            border-color: $primary-color;
            z-index: 2;
          }
        }
        &.selected {
          background-color: $primary-color;
          border-color: $primary-color;
          color: #fff;
          z-index: 2;
        }
        &.disabled {
          color: $light-border-color;
        }
        &.day-header {
          font-size: ((11/18) * 1em);
        }
      }
    }
    &__calendar-action {
      display: inline-block;
      line-height: 1;
      svg {
        display: inline-block;
        width: 1.2rem;
        height: 1.2rem;
        margin-left: 0.6rem;
        vertical-align: -0.2rem;
      }
    }
    &__date-field {
      opacity: 0;
      position: absolute;
      right: 0;
    }
    &__price-monitor-title {
      @include font-primary(bold);
      font-size: rem(16);
      margin: 0;
      color: $secondary-text-color;
    }
    &__field-wrapper--price-monitor &__field-extra {
      padding: 0 rem(19) rem(19);
    }
  }
  

  .uppgifterText {
    &__field-wrapper {
      margin-bottom: rem(24);
      font-size: rem(16);
      display: block;
      position: relative;
    }
    &__field-group &__field-wrapper {
      @include media('>lg') {
        flex-basis: calc(50% - #{rem(12)});
      }
    }
    &__field {
      @include unstyled-text-field;
      display: block;
      width: 100%;
      border: 1px solid $light-border-color;
      padding: #{(13/18)}em;
      &:focus,
      &:hover {
        border-color: $dark-border-color;
      }
      &::placeholder {
        color: $dark-border-color;
      }
    }
    &__field-label {
      @include font-primary;
      color: $secondary-text-color;
      margin: 0 0 rem(6);
      display: block;
      &--title {
        @include font-primary(bold);
        color: $secondary-text-color;
        font-size: rem(18);
        display: block;
        margin: 0 0 rem(9);
      }
      em {
        font-style: normal;
        color: #c00;
      }
    }
	
	&__field_placeholder_style::-webkit-input-placeholder {
		font-style: italic;
	}
	&__field_placeholder_style:-moz-placeholder {
		font-style: italic;  
	}
	&__field_placeholder_style::-moz-placeholder {
		font-style: italic;  
	}
	&__field_placeholder_style:-ms-input-placeholder {  
		font-style: italic; 
	}
    &__feedback {
		margin-top: -15px;
		margin-bottom: 20px;
	}

  }
</style>
